export var userTracksAvailableFileTypes = [
    "mp3",
    "ogg",
    "wav",
    "flac",
    "aac",
    "aiff",
];
